<template>
  <div id="contactUs" class="contactUs-padding">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.contact-us') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.contact-us') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <p>
            {{ $t('message.contact-us-text') }}
            <a
              href="mailto:lexin@oslomet.no"
            >lexin@oslomet.no</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "ContactUsComponent",
     data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>


